var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticStyle: { float: "left" } }, [
      _c("h1", [_vm._v(_vm._s(_vm.translateWords.AreaManage))])
    ]),
    _vm._v(" "),
    _c("table", { staticStyle: { width: "800px" } }, [
      _vm._m(0),
      _vm._v(" "),
      _c("tr", [
        _c(
          "td",
          [
            _vm.istableshow
              ? _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      model: _vm.ruleForm,
                      rules: _vm.rules,
                      "label-width": "100px"
                    }
                  },
                  [
                    _c("table", [
                      _c("tr", [
                        _c(
                          "td",
                          { staticStyle: { width: "800px" } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.translateWords.RegionNameLabel,
                                  prop: "RegionName"
                                }
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value: _vm.ruleForm.RegionName,
                                    callback: function($$v) {
                                      _vm.$set(_vm.ruleForm, "RegionName", $$v)
                                    },
                                    expression: "ruleForm.RegionName"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c(
                          "td",
                          { attrs: { align: "left" } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.translateWords.StatusLabel,
                                  prop: "Status"
                                }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder:
                                        _vm.translateWords.SelectPlaceholder
                                    },
                                    model: {
                                      value: _vm.ruleForm.Status,
                                      callback: function($$v) {
                                        _vm.$set(_vm.ruleForm, "Status", $$v)
                                      },
                                      expression: "ruleForm.Status"
                                    }
                                  },
                                  _vm._l(_vm.regionstatusoptions, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { staticStyle: { float: "left" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.submitForm("ruleForm")
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.translateWords.SaveBtn))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("tr", [
        _c(
          "td",
          [
            _vm.istableshow
              ? _c(
                  "el-table",
                  {
                    ref: "tableref",
                    staticStyle: { width: "80%" },
                    attrs: { data: _vm.tableData, "highlight-current-row": "" },
                    on: { "current-change": _vm.handleCurrentChange }
                  },
                  [
                    false
                      ? _c("el-table-column", {
                          attrs: { prop: "Id", label: "Id", width: "180" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "RegionName",
                        label: _vm.translateWords.RegionNameLabel,
                        width: "380"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input", {
                                  staticClass: "RegionName",
                                  model: {
                                    value: scope.row.RegionName,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "RegionName", $$v)
                                    },
                                    expression: "scope.row.RegionName"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        823785801
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "Status",
                        label: _vm.translateWords.StatusLabel2,
                        width: "200"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { filterable: "" },
                                    model: {
                                      value: scope.row.Status,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "Status", $$v)
                                      },
                                      expression: "scope.row.Status"
                                    }
                                  },
                                  _vm._l(_vm.rowregionstatusoptions, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        355426448
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: _vm.translateWords.OperationLabel },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "danger" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleDeleteRegion(
                                          scope.$index,
                                          scope.row
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.translateWords.DeleteBtnText)
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleEditRegion(
                                          scope.$index,
                                          scope.row
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.translateWords.AddBtnText)
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3814462106
                      )
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [
          _c("div", { staticStyle: { float: "left" } }, [
            _c("h1", [_vm._v(_vm._s(_vm.translateWords.RoomManageText))])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-form",
              {
                ref: "ruleForm1",
                staticClass: "demo-ruleForm",
                attrs: {
                  model: _vm.ruleForm1,
                  rules: _vm.rules1,
                  "label-width": "100px"
                }
              },
              [
                _c("table", [
                  _c("tr", [
                    _c(
                      "td",
                      { staticStyle: { width: "700px" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.translateWords.LocalName,
                              prop: "PositionName"
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.ruleForm1.PositionName,
                                callback: function($$v) {
                                  _vm.$set(_vm.ruleForm1, "PositionName", $$v)
                                },
                                expression: "ruleForm1.PositionName"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { attrs: { align: "left" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.translateWords.AreaStatus,
                              prop: "IsUseRegion"
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder:
                                    _vm.translateWords.SelectPlaceholder
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.selectvalue(
                                      _vm.ruleForm1.IsUseRegion
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.ruleForm1.IsUseRegion,
                                  callback: function($$v) {
                                    _vm.$set(_vm.ruleForm1, "IsUseRegion", $$v)
                                  },
                                  expression: "ruleForm1.IsUseRegion"
                                }
                              },
                              _vm._l(_vm.IsUseRegionoption, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { attrs: { align: "left" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.translateWords.RoomStatus,
                              prop: "Status"
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder:
                                    _vm.translateWords.SelectPlaceholder
                                },
                                model: {
                                  value: _vm.ruleForm1.Status,
                                  callback: function($$v) {
                                    _vm.$set(_vm.ruleForm1, "Status", $$v)
                                  },
                                  expression: "ruleForm1.Status"
                                }
                              },
                              _vm._l(_vm.positionstatusoptions, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { attrs: { align: "left" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.translateWords.SelectArea,
                              prop: "RegionId"
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder:
                                    _vm.translateWords.SelectPlaceholder
                                },
                                model: {
                                  value: _vm.ruleForm1.RegionId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.ruleForm1, "RegionId", $$v)
                                  },
                                  expression: "ruleForm1.RegionId"
                                }
                              },
                              _vm._l(_vm.form1regionstatusoptions, function(
                                item
                              ) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { staticStyle: { float: "left" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.submitForm1("ruleForm1")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.translateWords.SaveBtn))]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-table",
              { attrs: { data: _vm.positiontableData } },
              [
                false
                  ? _c("el-table-column", {
                      attrs: { prop: "Id", label: "Id", width: "180" }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "PositionName",
                    label: _vm.translateWords.Local,
                    width: "400"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("el-input", {
                            staticClass: "PositionName",
                            model: {
                              value: scope.row.PositionName,
                              callback: function($$v) {
                                _vm.$set(scope.row, "PositionName", $$v)
                              },
                              expression: "scope.row.PositionName"
                            }
                          })
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "RegionName",
                    label: _vm.translateWords.Area,
                    width: "300"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-select",
                            {
                              model: {
                                value: scope.row.RegionName,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "RegionName", $$v)
                                },
                                expression: "scope.row.RegionName"
                              }
                            },
                            _vm._l(_vm.rowregionnameoptions, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.label }
                              })
                            }),
                            1
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.translateWords.IsUserRoom,
                    prop: "Status",
                    width: "200"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-select",
                            {
                              model: {
                                value: scope.row.Status,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "Status", $$v)
                                },
                                expression: "scope.row.Status"
                              }
                            },
                            _vm._l(_vm.rowpositionstatusoptions, function(
                              item
                            ) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.translateWords.IsUseArea,
                    prop: "IsUseRegion",
                    width: "200"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-select",
                            {
                              model: {
                                value: scope.row.IsUseRegion,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "IsUseRegion", $$v)
                                },
                                expression: "scope.row.IsUseRegion"
                              }
                            },
                            _vm._l(_vm.rowpositionIsUseRegionoptions, function(
                              item
                            ) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: _vm.translateWords.Opearation, width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "danger" },
                              on: {
                                click: function($event) {
                                  return _vm.handleDeletePosition(
                                    scope.$index,
                                    scope.row
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.translateWords.DeleteBtnText))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.handleEditPosition(
                                    scope.$index,
                                    scope.row
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.translateWords.SaveBtn))]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" -->\n")
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [_c("td")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-755a3324", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-755a3324","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Region.vue
// module id = mhNo
// module chunks = 1